
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

export default function SitemapGeneratorTrigger() {
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState<any>(null);
  
  const triggerSitemapGeneration = async () => {
    setIsLoading(true);
    try {
      // Call the edge function that regenerates sitemaps
      const { data, error } = await supabase.functions.invoke('sitemap-generator-cron', {});
      
      if (error) {
        console.error('Error triggering sitemap generation:', error);
        toast.error(`Failed to trigger sitemap generation: ${error.message}`);
        setResults({ error: error.message });
        return;
      }
      
      console.log('Sitemap generation triggered successfully:', data);
      toast.success('Sitemap generation triggered successfully. Check the logs for details.');
      
      setResults(data);
    } catch (error: any) {
      console.error('Exception triggering sitemap generation:', error);
      toast.error(`Exception: ${error.message}`);
      setResults({ exception: error.message });
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Sitemap Generator</h2>
      <p className="mb-4 text-gray-600">
        Click the button below to manually trigger sitemap generation. 
        This will create or update all sitemap files.
      </p>
      
      <Button 
        onClick={triggerSitemapGeneration}
        disabled={isLoading}
      >
        {isLoading ? 'Generating...' : 'Generate Sitemaps Now'}
      </Button>
      
      {results && (
        <div className="mt-6">
          <h3 className="text-lg font-medium mb-2">Results</h3>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto max-h-60">
            {JSON.stringify(results, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
